export default __webpack_public_path__ + "static/eco-sustainability_bg-3-292031af23b36b339238db000ad821e4.svg";